export const PIN_MASK = '####-####';
export const PIN_LENGTH = 8;
//# sourceMappingURL=pin.js.map